module.exports = __webpack_public_path__ + "img/Asset-208-100.af478f86.jpg";